// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"3265217e","440":"4f7853b7","552":"59074c6a","604":"f4b10e65","732":"b892ceed","812":"6a261591"}[chunkId] + ".chunk.js";
};